// Texty predpokladaného naskladnenia (restockDate.js): detail aj karta.
export default {
  /** „Naskladnenie očakávame do 8. 10." (dátum už končí bodkou) */
  expected: (date) => 'Naskladnenie očakávame do ' + date,
  /** zvyšok vety panelu vypredaného za termínom (detail) */
  detailRest: 'Postrážime to za vás a dáme vám vedieť e-mailom, hneď ako bude opäť k dispozícii.',
  // --- čítanie natívneho textu Shoptetu ---
  /** dostupnosť vypredaného na karte: SK shop nepoužíva dostupnosti, web píše
   *  podľa skladu „Vypredané"; „Momentálne nedostupné" ako záloha */
  soldOutRe: /vypredan|nedostupn/i,
};
